import { FC } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import GameCard from "../GameCard";

type HorizontalLayoutProps = {
  gameIds: string[];
  isStacked?: boolean;
  isNewlyGenerated?: boolean;
};

const HorizontalLayout: FC<HorizontalLayoutProps> = ({
  gameIds,
  isStacked,
  isNewlyGenerated,
}) => {
  const firstRow = gameIds?.slice(0, 7) || [];
  const secondRow = gameIds?.slice(7, 14) || [];

  return (
    <FlexColumn gap={2}>
      <SpaceBetweenCenter gap={2}>
        {firstRow.map((gameId, index) => (
          <GameCard
            key={gameId}
            gameId={gameId}
            imageWidth="124px"
            imageHeight="81px"
            maxWidth="124px"
            index={index}
            isNewlyGenerated={isNewlyGenerated}
          />
        ))}
      </SpaceBetweenCenter>

      {isStacked && (
        <SpaceBetweenCenter gap={2}>
          {secondRow.map((gameId, index) => (
            <GameCard
              key={gameId}
              gameId={gameId}
              imageWidth="124px"
              imageHeight="81px"
              maxWidth="124px"
              index={index + 7}
              isNewlyGenerated={isNewlyGenerated}
            />
          ))}
        </SpaceBetweenCenter>
      )}
    </FlexColumn>
  );
};

export default HorizontalLayout;
